

























import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputGroupStepper: iwInputGroupStepper,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.livingDescription.habitableUnitCount",
            pathInStoreUI: "property.hasDwellings",
            inputName: "habitable-unit-count",
            specificId: uuidv4() as string
        };
    },
    computed: {
        habitableUnitCount: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        hasDwellings: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"](this.pathInStoreUI);
        }
    },
    methods: {
        updateValue: function(habitableUnitCount: number): void {
            if (!this.hasDwellings || habitableUnitCount === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": habitableUnitCount});
            }
        }
    }
});

